import api from "../api";

import {REQUEST, SUCCESS, FAILURE} from './action-type.util';

export const ACTION_TYPES = {
    FETCH_WEBHOOK_LIST: 'webhook/FETCH_WEBHOOK_LIST',
    FETCH_WEBHOOK: 'webhook/FETCH_WEBHOOK',
    CREATE_WEBHOOK: 'webhook/CREATE_WEBHOOK',
    UPDATE_WEBHOOK: 'webhook/UPDATE_WEBHOOK',
    DELETE_WEBHOOK: 'webhook/DELETE_WEBHOOK',
    RESET: 'webhook/RESET',
};

const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    entity: {},
    updating: false,
    updateSuccess: false,
};

// Reducer
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_WEBHOOK_LIST):
        case REQUEST(ACTION_TYPES.FETCH_WEBHOOK):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_WEBHOOK):
        case REQUEST(ACTION_TYPES.UPDATE_WEBHOOK):
        case REQUEST(ACTION_TYPES.DELETE_WEBHOOK):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_WEBHOOK_LIST):
        case FAILURE(ACTION_TYPES.FETCH_WEBHOOK):
        case FAILURE(ACTION_TYPES.CREATE_WEBHOOK):
        case FAILURE(ACTION_TYPES.UPDATE_WEBHOOK):
        case FAILURE(ACTION_TYPES.DELETE_WEBHOOK):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_WEBHOOK_LIST):
            return {
                ...state,
                loading: false,
                entities: action.payload.data,
            };
        case SUCCESS(ACTION_TYPES.FETCH_WEBHOOK):
            return {
                ...state,
                loading: false,
                entity: action.payload.data,
            };
        case SUCCESS(ACTION_TYPES.CREATE_WEBHOOK):
        case SUCCESS(ACTION_TYPES.UPDATE_WEBHOOK):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: action.payload.data,
            };
        case SUCCESS(ACTION_TYPES.DELETE_WEBHOOK):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: {},
            };
        case ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

const apiUrl = '/system/webhooks';

// Actions
export const getEntities = (environmentId) => ({
    type: ACTION_TYPES.FETCH_WEBHOOK_LIST,
    payload: api.instance.get(`${apiUrl}?environmentId=${environmentId}&cacheBuster=${new Date().getTime()}`),
});

export const getEntity = id => ({
    type: ACTION_TYPES.FETCH_WEBHOOK,
    payload: api.instance.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
    return await dispatch({
        type: ACTION_TYPES.CREATE_WEBHOOK,
        payload: api.instance.post(`${apiUrl}`, entity),
    });
};

export const updateEntity = entity => async dispatch => {
    return await dispatch({
        type: ACTION_TYPES.UPDATE_WEBHOOK,
        payload: api.instance.put(`${apiUrl}/${entity.id}`, entity),
    });
};

export const deleteEntity = id => async dispatch => {
    return await dispatch({
        type: ACTION_TYPES.DELETE_WEBHOOK,
        payload: api.instance.delete(`${apiUrl}/${id}`),
    });
};

export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
